module.exports = __webpack_public_path__ + "img/success.e7d4f4f8.png";